/**
 * Daktilo animasyonu - SAF adim fonksiyonu.
 *
 * ## `floor` (commit tabani) neden var
 *
 * Vanilla arayuzun typer'i `step = netDone ? backlog : max(1, ceil(backlog/5))`
 * kullaniyordu. Tek bir alan eklenerek genelleştirildi: `floor` = ALTINDAKI
 * metnin ANINDA gosterildigi indeks.
 *
 * `floor` tam olarak dort durumda `full.length`e cikiyor:
 *
 *   1. **`resume` cercevesi geldiginde.** Yeniden baglanmada 3000 karakter
 *      replay edilebilir; onu yeniden DAKTILO ETMEK saniyeler surer ve
 *      kullaniciya "uygulama gecmisi yeniden yaziyor" gibi gorunur.
 *      "3000 token yeniden daktilo edilmemeli" gereksinimi boylece bir
 *      heuristikle degil YAPISAL olarak cozuluyor.
 *   2. **Gecmisten yuklenen mesajlar** - typer'a hic girmiyorlar.
 *   3. **`prefers-reduced-motion: reduce`** - hic animasyon yok. CSS tek
 *      basina bir JS animasyonunu KAPATMIYOR; tuzak tam burada.
 *   4. **`document.hidden`** - tarayicilar arka plan sekmesinde rAF'i ~1 Hz'e
 *      kisiyor. Bu olmadan typer binlerce karakter geriye duser ve sekmeye
 *      donuldugunde gorunur bir sarsintiyla "yetisir".
 *
 * ## Ust ve alt sinirlar
 *
 * `backlog > 400` -> hepsini goster: asla cok geride kalmiyor.
 * frame basina en fazla 60 karakter -> hizli akista bile okunabilir kaliyor.
 */

export interface TyperState {
  /** Sunucudan gelen TAM metin. */
  full: string
  /** Su an gosterilen karakter sayisi. */
  shown: number
  /** Bu indeksin altindaki metin ANINDA gosteriliyor. */
  floor: number
  /** Ag akisi bitti mi (uretim tamamlandi). */
  netDone: boolean
}

/** Bir frame'de gosterilecek YENI karakter sayisi ust siniri. */
export const MAX_STEP = 60
/** Bu kadar geride kalindiysa animasyonu birak, hepsini goster. */
export const CATCH_UP_THRESHOLD = 400

/**
 * Sonraki frame'de `shown` kac olmali?
 *
 * Saf: girdi state'i DEGISTIRMIYOR. Cagiran donen degeri yaziyor.
 */
export function nextShown(state: TyperState): number {
  // Commit tabani her zaman once uygulaniyor: replay edilen metin
  // animasyonsuz, ANINDA gorunuyor.
  const shown = Math.max(state.shown, state.floor)
  const backlog = state.full.length - shown
  if (backlog <= 0) return shown

  if (state.netDone) return state.full.length
  if (backlog > CATCH_UP_THRESHOLD) return state.full.length

  const step = Math.max(1, Math.min(MAX_STEP, Math.ceil(backlog / 5)))
  return shown + step
}

/** Animasyon gerekiyor mu? `false` ise rAF dongusu hic kurulmuyor. */
export function needsAnimation(state: TyperState): boolean {
  return Math.max(state.shown, state.floor) < state.full.length
}

/**
 * Animasyonun tamamen atlanmasi gereken durumlar.
 *
 * Ayri bir fonksiyon: cagiran bunu `floor = full.length` yapmak icin
 * kullaniyor ve karar SAF kaliyor (test edilebilir), tarayici API'lerine
 * gomulmuyor.
 */
export function shouldSkipAnimation(options: {
  reducedMotion: boolean
  hidden: boolean
  fromHistory: boolean
  fromResume: boolean
}): boolean {
  return (
    options.reducedMotion || options.hidden || options.fromHistory || options.fromResume
  )
}
